module.exports = __webpack_public_path__ + "assets/materialdesignicons-webfont.63d2a5950fc212096c3612f71ae66f64.woff";